import { render, staticRenderFns } from "./AddCard.vue?vue&type=template&id=069cbe97"
import script from "../controllers/AddCard.ts?vue&type=script&lang=ts&external"
export * from "../controllers/AddCard.ts?vue&type=script&lang=ts&external"
import style0 from "./AddCard.vue?vue&type=style&index=0&id=069cbe97&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports